import { configureChains, createConfig } from 'wagmi';
import {
  avalanche,
  bsc,
  mainnet,
  bscTestnet,
  fantom,
  optimism,
  polygon,
  klaytn,
  arbitrum,
  gnosis,
  aurora,
  moonbeam,
  zkSync,
  harmonyOne,
  okc,
  pulsechain,
  manta,
  metis,
  confluxESpace,
  cronos,
  meter,
  kava,
  base,
  canto,
  linea,
} from 'wagmi/chains';
import { MetaMaskConnector } from 'wagmi/connectors/metaMask';
import { WalletConnectConnector } from 'wagmi/connectors/walletConnect';
import { InjectedConnector } from 'wagmi/connectors/injected';
import { publicProvider } from 'wagmi/providers/public';
// import { LedgerConnector } from 'wagmi/connectors/ledger';
import { CoinbaseWalletConnector } from 'wagmi/connectors/coinbaseWallet';
import { MultiverxConnector } from './../connectors/MultiverxConnector';
import { TronConnector } from '../connectors/TronConnector';
import { TonConnector } from '../connectors/TonConnector';
import { TrezorConnector } from '../connectors/TrezorConnector';
// import { infuraProvider } from 'wagmi/providers/infura';
// import { helpers } from '@kattana-io/common';
// import { UnstoppableDomainsConnector } from '../connectors/UnstoppableDomains';

import {
  elrondChain,
  tronChain,
  // hecoChain,
  bttcChain,
  tonChain,
  artheraChain,
} from './customChains';

// @todo add infuraProvider({ apiKey: process.env.REACT_APP_INFURA_ID })
const { chains, publicClient, webSocketPublicClient } = configureChains(
  [
    okc,
    // hecoChain,
    bttcChain,
    avalanche,
    bsc,
    mainnet,
    bscTestnet,
    fantom,
    manta,
    metis,
    confluxESpace,
    cronos,
    meter,
    kava,
    base,
    canto,
    {
      ...optimism,
      rpcUrls: {
        ...optimism.rpcUrls,
        default: {
          http: ['https://optimism.publicnode.com'],
        },
        public: {
          http: ['https://optimism.publicnode.com'],
        },
      },
    },
    polygon,
    klaytn,
    arbitrum,
    gnosis,
    aurora,
    moonbeam,
    zkSync,
    harmonyOne,
    linea,
    pulsechain,
    artheraChain,
  ],
  [publicProvider()]
);

const walletConnectConnector = new WalletConnectConnector({
  chains,
  options: { projectId: '49fa7d7a625b9e45ef1234dd8388af81' },
});

// const ledgerConnector = new LedgerConnector({
//   chains,
//   options: {
//     walletConnectVersion: 2,
//     projectId: '49fa7d7a625b9e45ef1234dd8388af81',
//   },
// });

const injectedConnector = new InjectedConnector({
  chains,
  options: {
    shimDisconnect: true,
  },
});

const coinbaseWalletConnector = new CoinbaseWalletConnector({
  chains,
  options: {
    appName: 'app.kattana.io',
  },
});

const multiverxConnector = new MultiverxConnector([elrondChain]);

const tronConnector = new TronConnector([tronChain]);

const tonConnector = new TonConnector([tonChain]);

const trezorConnector = new TrezorConnector([mainnet]);

const metaMaskConnector = new MetaMaskConnector({ chains });

// @todo finish UD connector (trouble with signer - no idea how to get him)
// const unstoppableDomainsConnector = new UnstoppableDomainsConnector({
//   options: {
//     clientID: '5cf4e887-c7a0-4502-a633-353cfdedfc5e',
//     redirectUri: 'http://localhost:3000/',
//     postLogoutRedirectUri: 'http://localhost:3000/',
//     scope: 'openid wallet',
//   },
// });

export const getConfig = () => {
  const config = createConfig({
    autoConnect: false,
    publicClient,
    webSocketPublicClient,
    connectors: [
      metaMaskConnector,
      multiverxConnector,
      tronConnector,
      walletConnectConnector,
      // ledgerConnector,
      injectedConnector,
      coinbaseWalletConnector,
      tonConnector,
      trezorConnector,
      // unstoppableDomainsConnector,
    ],
  });

  return config;
};
